module.exports = __webpack_public_path__ + "static/media/EIGHT.f7bd39ce.png";